import React, { useEffect, useRef, useState } from 'react'
import { string } from 'prop-types'
import { useGlobal } from '../../../../contexts/GlobalContext'
import { navigateParaHome } from '../../../../utils/rotas/navigate'
import { temAssinaturaClubeNormal } from '../../../../utils/helpers/helpersToken'
import logoBookster from '../../assets/logo-bookster.png'
import { CENTRAL_AJUDA } from '../../data/links'
import IcoChevron from '../icons/IcoChevron'
import {
  TopBarRoot,
  Container,
  Logo,
  Nav,
  NavLink,
  MemberWrap,
  Member,
  MemberInfo,
  MemberName,
  MemberPlan,
  Avatar,
  MemberChevron,
  Dropdown,
  DropdownItem,
  DropdownItemMobileOnly,
  DropdownDivider
} from './styles'

function computeInitials( nomeCompleto ) {
  const partes = ( nomeCompleto || '' ).trim().split( /\s+/u )
    .filter( Boolean )
  if ( partes.length === 0 ) {
    return '—'
  }
  const first = partes[ 0 ].charAt( 0 )
  const last = partes.length > 1 ? partes[ partes.length - 1 ].charAt( 0 ) : ''
  return `${first}${last}`.toUpperCase()
}

export default function TopBar( { active, nome } ) {
  const { nomeAssociado, dadosGlobaisAssociado, fazLogout, getDadosGlobaisAssociado } = useGlobal()
  const nomeFonte = ( nome || nomeAssociado || dadosGlobaisAssociado?.associado?.nome || '' ).trim()
  const nomeCompleto = nomeFonte || 'Associado'
  const iniciais = computeInitials( nomeFonte )

  const [ menuAberto, setMenuAberto ] = useState( false )
  const wrapRef = useRef( null )

  const mostraClubesTag = temAssinaturaClubeNormal()

  const abrirClubesTag = () => {
    setMenuAberto( false )
    if ( !dadosGlobaisAssociado ) {
      getDadosGlobaisAssociado()
    }
    navigateParaHome()
  }

  useEffect( () => {
    function handleClickFora( event ) {
      if ( wrapRef.current && !wrapRef.current.contains( event.target ) ) {
        setMenuAberto( false )
      }
    }
    function handleEsc( event ) {
      if ( event.key === 'Escape' ) {
        setMenuAberto( false )
      }
    }
    if ( menuAberto ) {
      document.addEventListener( 'mousedown', handleClickFora )
      document.addEventListener( 'keydown', handleEsc )
    }
    return () => {
      document.removeEventListener( 'mousedown', handleClickFora )
      document.removeEventListener( 'keydown', handleEsc )
    }
  }, [ menuAberto ] )

  return (
    <TopBarRoot>
      <Container>
        <Logo
          alt="Bookster Pelo Mundo"
          src={ logoBookster }
        />
        <Nav>
          <NavLink
            $active={ active === 'assinatura' }
            href="/bookster"
            onClick={ ( event ) => event.preventDefault() }
          >
            Minha assinatura
          </NavLink>
          { mostraClubesTag ? (
            <NavLink
              as="button"
              onClick={ abrirClubesTag }
              type="button"
            >
              Clubes TAG
            </NavLink>
          ) : null }
          <NavLink
            href={ CENTRAL_AJUDA }
            rel="noopener noreferrer"
            target="_blank"
          >
            Ajuda
          </NavLink>
        </Nav>
        <MemberWrap ref={ wrapRef }>
          <Member
            aria-expanded={ menuAberto }
            aria-haspopup="menu"
            onClick={ () => setMenuAberto( ( aberto ) => !aberto ) }
            type="button"
          >
            <MemberInfo>
              <MemberName>{ nomeCompleto }</MemberName>
              <MemberPlan>Plano Anual · Bookster Pelo Mundo</MemberPlan>
            </MemberInfo>
            <Avatar>{ iniciais }</Avatar>
            <MemberChevron $open={ menuAberto }>
              <IcoChevron
                height="14"
                width="14"
              />
            </MemberChevron>
          </Member>
          { menuAberto ? (
            <Dropdown role="menu">
              { mostraClubesTag ? (
                <DropdownItemMobileOnly
                  onClick={ abrirClubesTag }
                  role="menuitem"
                  type="button"
                >
                  Clubes TAG
                </DropdownItemMobileOnly>
              ) : null }
              <DropdownItemMobileOnly
                as="a"
                href={ CENTRAL_AJUDA }
                rel="noopener noreferrer"
                role="menuitem"
                target="_blank"
              >
                Ajuda
              </DropdownItemMobileOnly>
              <DropdownDivider />
              <DropdownItem
                onClick={ fazLogout }
                role="menuitem"
                type="button"
              >
                Sair
              </DropdownItem>
            </Dropdown>
          ) : null }
        </MemberWrap>
      </Container>
    </TopBarRoot>
  )
}

TopBar.propTypes = {
  'active': string,
  'nome': string
}

TopBar.defaultProps = {
  'active': 'assinatura',
  'nome': ''
}
